/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



const __vue_script__ = {
    name: 'AuthContainer',

    props: {
        backToLoginInHeader: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            appName: window.BSTG.appName,
            loading: true,
            askLogout: false
        };
    },

    async created() {
        // If there is a reset_token, being logged in doesn't matter, we go to the reset page anyway.
        if (await this.isUserAutheticated() && !this.$route.query.reset_token) {
            // Handling the use case of a logged in user requesting an activation (mostly dev)
            if (this.$route.query.token) {
                this.askLogout = true;
                this.loading = false;
            } else {
                console.info('[Auth] Redirecting to backstage app.');
                this.$services.router.redirectToHome();
            }
            return;
        }

        // Here we check routes parameters and redirect to the proper path
        // because the BE and the email links will, for some time, still use
        // the unique root ('/') route for catching all the authentication
        // scenarios (login, account activation, change password).
        // It's a backward compatibility coming from the AngularJS implementation
        // where a single controller was handling everything.
        // We could eventually get rid of it once all routes will be updated
        // on BE and emails.

        const lastSsoDomain = this.$services.sso.getLastDomain();
        let forgetSSO = true;

        if (this.$route.path !== this.$const.ROUTE_RESET_PASSWORD && this.$route.query.reset_token) {
            this.$router.replace({
                path: this.$const.ROUTE_RESET_PASSWORD,
                query: this.$route.query
            });

        } else if (this.$route.path === this.$const.ROUTE_RESET_PASSWORD && !this.$route.query.reset_token) {
            this.$router.replace(this.$const.ROUTE_LOGIN);

        }

        if (this.$route.path !== this.$const.ROUTE_CONFIRM_ACCOUNT && this.$route.query.token) {
            this.$router.replace({
                path: this.$const.ROUTE_CONFIRM_ACCOUNT,
                query: this.$route.query
            });

        } else if (this.$route.path === this.$const.ROUTE_CONFIRM_ACCOUNT && !this.$route.query.token) {
            this.$router.replace(this.$const.ROUTE_LOGIN);

        } else if (lastSsoDomain && this.$route.name !== 'sso') {
            this.$router.replace(this.$const.ROUTE_LOGIN_WITH_SSO);
            forgetSSO = false;
        }

        if (forgetSSO) {
            this.$services.sso.forgetLastDomain();
        }

        this.loading = false;
    },

    methods: {

        /**
         * Checks if the user is authenticated or not.
         *
         * @returns {Promise<boolean>} wheter the user is authenticated or not
         */
        async isUserAutheticated() {
            try {
                await this.$services.session.checkSession();
                console.info('[Auth] User is authenticated');
                return true;

            } catch (error) {
                console.info('[Auth] User is not authenticated');
                return false;
            }
        },

        /**
         * Logs the user out
         */
        async logout() {
            await this.$services.session.logout();
            console.info('[Auth] User is logged out');
            this.$services.router.redirectToHome();
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-container",class:{ loading: _vm.loading, 'back-to-login': _vm.backToLoginInHeader }},[(_vm.backToLoginInHeader)?_c('header',[_c('router-link',{staticClass:"back-to-login",attrs:{"to":_vm.$const.ROUTE_LOGIN,"title":_vm.$t('login.links.return_to_login')}},[_c('i',{staticClass:"ic-chevron-left"})])],1):_c('header',[_c('h1',[_c('img',{attrs:{"src":_vm.$utils.assets.imagePath('spotme-onomi.svg'),"alt":_vm.$t('login.title', [_vm.appName])}})])]),_c('section',[(_vm.askLogout)?_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t('login.errors.logout_before_login')))]),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"action"},[_c('a',{staticClass:"btn btn-login",on:{"click":_vm.logout}},[_vm._v(_vm._s(_vm.$t('login.forms.actions.logout')))])])])]):_vm._t("default")],2),_c('footer',[_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://spotme.com/help","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.$t('login.links.support')))])]),_c('li',[_c('a',{attrs:{"href":"https://spotme.com/privacy","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.$t('login.links.privacy')))])]),_c('li',[_c('a',{attrs:{"href":"https://spotme.com","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.$t('login.links.website')))])]),_c('li',[_c('a',{attrs:{"href":"https://onomi.io","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.$t('login.links.website_onomi')))])])])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "AuthContainer.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__